import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { SiteProvider } from "@/context/SiteContext";
import { FavouritesProvider } from "@/context/FavouritesContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { Shortlist } from "@/components/site/Shortlist";
import { Header, Footer, armFromPath } from "@/components/site/Chrome";
import { FloatingWhatsApp } from "@/components/site/Contact";
import Home from "@/pages/Home";
import OilGas from "@/pages/OilGas";
import Realty from "@/pages/Realty";
import Development from "@/pages/Development";
import { PropertyDetail, ProjectDetail } from "@/pages/Detail";
import Shortlets from "@/pages/Shortlets";
import ShortletDetail from "@/pages/ShortletDetail";
import BookingPay from "@/pages/BookingPay";
import AdminDashboard, { AdminLogin } from "@/pages/Admin";

const SiteLayout = () => {
  const { pathname } = useLocation();
  const arm = armFromPath(pathname);
  return (
    <div className={`theme-${arm} bg-gw-ground min-h-screen transition-colors duration-300`} data-testid={`site-theme-${arm}`}>
      <Header />
      <main id="top"><Outlet /></main>
      <Footer />
      <FloatingWhatsApp />
      {arm === "realty" && <Shortlist />}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <SiteProvider>
          <FavouritesProvider>
          <CurrencyProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/oil-gas" element={<OilGas />} />
                <Route path="/realty" element={<Realty />} />
                <Route path="/realty/:id" element={<PropertyDetail />} />
                <Route path="/shortlets" element={<Shortlets />} />
                <Route path="/shortlets/:id" element={<ShortletDetail />} />
                <Route path="/booking/:token" element={<BookingPay />} />
                <Route path="/development" element={<Development />} />
                <Route path="/development/:id" element={<ProjectDetail />} />
              </Route>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-left" />
          </CurrencyProvider>
          </FavouritesProvider>
        </SiteProvider>
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
